"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowItem = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var userLens_1 = require("@caddigital/sok-reducers/lib/utils/userLens");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var components_1 = require("components");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
require("./style.scss");
var RowItem = function (_a) {
    var row = _a.row, props = _a.props;
    return (React.createElement(sok_ui_1.Table.Row, { className: 'addressbook-row' },
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement(components_1.TableRowIcon, { icon: 'fa-check', circle: true, onClick: props.addressBook.selected.indexOf(row.id) > -1
                    ? props.unselectAddressBookList([row.id])
                    : props.selectAddressBookList([row.id]), className: props.addressBook.selected.indexOf(row.id) > -1 ? 'selected' : null })),
        React.createElement(sok_ui_1.Table.Column, null),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, userLens_1.getName.get(row)) },
                React.createElement("span", null, userLens_1.getName.get(row)))),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, userLens_1.getAddress.get(row)) },
                React.createElement("span", null, userLens_1.getAddress.get(row)))),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, row.company) },
                React.createElement("span", null, row.company)))));
};
exports.RowItem = RowItem;
var setList = function (props, users) {
    var searchString = props.searchString.toLowerCase();
    var items = users.filter(function (x) {
        if (userLens_1.getName.get(x).toLowerCase().includes(searchString) ||
            x.email.includes(searchString)) {
            return true;
        }
        return false;
    });
    props.setItems(items);
};
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('searchString', 'setSearchString', ''), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        if (this.props.addressBook.list.status === 'FETCHED') {
            setList(this.props, this.props.addressBook.list.users);
        }
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.addressBook.list.status === 'FETCHED' &&
            prevProps.addressBook.list.status === 'FETCHING') {
            setList(this.props, this.props.addressBook.list.users);
        }
        else if (this.props.addressBook.list.status !== 'FETCHED' ||
            prevProps.addressBook.list.status !== 'FETCHED') {
            return;
        }
        else {
            var items = this.props.addressBook.list.users;
            if (this.props.searchString !== prevProps.searchString ||
                this.props.addressBook.list.users !== prevProps.addressBook.list.users) {
                setList(this.props, items);
            }
        }
    }
}), recompose_1.pure);
var AddressBook = enhance(function (props) { return (React.createElement("div", { className: 'distribution-and-order-address-book' },
    React.createElement(sok_ui_1.TextInput, { className: 'white', placeholder: 'Search', icon: React.createElement(Icon_1.Icon, { className: 'fa-search' }), value: props.searchString, onChange: function (e) { return props.setSearchString(e.target.value); } }),
    React.createElement("div", { className: 'vertically-scrollable-list' },
        React.createElement(sok_ui_1.Table.Table, { className: 'striped hovered' },
            React.createElement(sok_ui_1.Table.Head, null,
                React.createElement(sok_ui_1.Table.Row, null,
                    React.createElement(sok_ui_1.Table.Column, null),
                    React.createElement(sok_ui_1.Table.Column, null),
                    React.createElement(sok_ui_1.Table.Column, null, (0, translation_1.getLocalization)('userfront/order/addressbook/name')),
                    React.createElement(sok_ui_1.Table.Column, null, (0, translation_1.getLocalization)('userfront/order/addressbook/contact')),
                    React.createElement(sok_ui_1.Table.Column, null, (0, translation_1.getLocalization)('userfront/order/addressbook/company')))),
            React.createElement(sok_ui_1.Table.Body, null, props.addressBook.list.status === 'FETCHED' &&
                props.items.map(function (row) { return (React.createElement(exports.RowItem, { key: row.id, row: row, props: props })); })))),
    props.addressBook.list.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, null,
        React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: props.currentFolder && props.fetchExternalUsers(props.currentFolder) }))),
    props.addressBook.list.status === 'FETCHING' && (React.createElement("div", { className: 'fetching-external-users' },
        React.createElement(sok_ui_1.LoadingSpinner, null))))); });
exports.default = AddressBook;
